import { Directive } from "@angular/core";
import {
    AbstractControl,
    NG_VALIDATORS,
    ValidationErrors,
    Validator,
    ValidatorFn
} from "@angular/forms";

@Directive({
    selector:
        "[phoneValidator][ngModel],[phoneValidator][formControl],[phoneValidator][formControlName]",
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: PhoneValidatorDirective,
            multi: true,
        },
    ],
})
export class PhoneValidatorDirective implements Validator {
    validate(control: AbstractControl): ValidationErrors | null {
        return phoneValidator()(control);
    }
}

export function phoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null;

        let validatePhone = '';
        let phone = control.value.replace(/\D/g, '');

        if (phone.length === 11) {
            validatePhone = phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        }

        if (phone.length === 10) {
            validatePhone = phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
        }

        const regex = /^\(\d{2}\)\s\d{4,5}-\d{4}$/;
        return regex.test(validatePhone) ? null : { phoneValidator: { valid: false } };
    };
}